var MpPagePrivacity;

(function() {
    if (!document.querySelector('#vue-privacity')) {
        return;
    }

    MpPagePrivacity = new Vue({
        el: '#vue-privacity',
        mixins: [MpStaticPage, MpScrollTo],

        data: {
            overlay: null,
            miniMap: null,

            isMapShown: false,
        },

        methods:{

            closeMapModal: function() {
                noScroll.off();
                this.isMapShown = false;
            },

            showMap: function() {
                noScroll.on();
                this.isMapShown = true;
            },

            init: function() {
                if (this.isInitialized) {
                    return;
                }

                this.isInitialized = true;
                this.overlay = this.$refs.overlay;
            },
        }
    });

})();
